import {handleActions} from "redux-actions"
import {NEXT_PAGE,BACK_PAGE,RESET_PAGE,SET_SEARCH,SET_SEARCH_VIEW,
        CITIZENS_LOADING} from "../actionTypes/citizensActions"
var update = require('immutability-helper')

const initialState={
  filters:{
    search:"",
    searchView:""
  },
  page:0,
  loading:false
}


const reducer=handleActions({
  [NEXT_PAGE]:(state,action)=>update(state,{page:{$set:state.page+1}}),
  [BACK_PAGE]:(state,action)=>update(state,{page:{$set:state.page-1}}),
  [RESET_PAGE]:(state,action)=>update(state,{page:{$set:initialState.page}}),
  [CITIZENS_LOADING]:(state,action)=>update(state,{loading:{$set:action.payload}}),
  [SET_SEARCH]:(state,action)=>update(state,{filters:{search:{$set:action.payload}}}),
  [SET_SEARCH_VIEW]:(state,action)=>update(state,{filters:{searchView:{$set:action.payload}}})
},initialState)

export default reducer
